import { LogType, LogTypeGroups } from "../../../../../../common/log_types";

const CreateIcons: LogType[] = [
	LogType.EventCreate,
	LogType.PollCreate,
	LogType.TimeFinderCreate,
];
const EditIcons: LogType[] = [
	LogType.EventEdit,
	LogType.PollEdit,
	LogType.PollAddOption,
	LogType.SettingsModify,
	LogType.TimeFinderEdit,
];
const DeleteIcons: LogType[] = [LogType.EventDelete, LogType.PollDelete, LogType.TimeFinderDelete];
const AddInteractionIcons: LogType[] = [
	LogType.EventAddRSVP,
	LogType.PollAddVote,
	LogType.TimeFinderVote,
];
const RemoveInteractionIcons: LogType[] = [
	LogType.EventRemoveRSVP,
	LogType.PollRemoveVote,
];

const TemplateCreateIcons: LogType[] = [LogType.EventTemplateFavorite];
const TemplateDeleteIcons: LogType[] = [LogType.EventTemplateUnfavorite];

const EndInteractionIcons: LogType[] = [LogType.PollForceEnd];

const PremiumIcons: LogType[] = [LogType.SettingsPremiumModify];

function matchLogType(type: keyof typeof LogTypeGroups, log_type: LogType) {
	return (LogTypeGroups[type] as any[]).includes(log_type);
}

export function LogIcon(props: { log_type: LogType }) {
	const { log_type } = props;

	let primary_icon_class: string;
	let secondary_icon: JSX.Element;
	if (matchLogType("Event", log_type)) {
		primary_icon_class = "fas fa-calendar-day";
	} else if (matchLogType("Poll", log_type)) {
		primary_icon_class = "fas fa-poll-h";
	} else if (matchLogType("Settings", log_type)) {
		primary_icon_class = "fas fa-cog";
	} else if (matchLogType("TimeFinder", log_type)) {
		primary_icon_class = "fas fa-clock";
	}

	if (CreateIcons.includes(log_type)) {
		secondary_icon = <i className="fas fa-plus-circle fa-sm" />;
	} else if (DeleteIcons.includes(log_type)) {
		secondary_icon = <i className="fas fa-ban fa-sm" />;
	} else if (AddInteractionIcons.includes(log_type)) {
		secondary_icon = <i className="fas fa-check-circle fa-sm" />;
	} else if (RemoveInteractionIcons.includes(log_type)) {
		secondary_icon = <i className="fas fa-times-circle fa-sm" />;
	} else if (EndInteractionIcons.includes(log_type)) {
		secondary_icon = <i className="fas fa-stop-circle fa-sm" />;
	} else if (EditIcons.includes(log_type)) {
		secondary_icon = <EditIcon />;
	} else if (PremiumIcons.includes(log_type)) {
		secondary_icon = <PremiumIcon />;
	} else if (TemplateCreateIcons.includes(log_type)) {
		secondary_icon = <AddTemplateIcon />;
	} else if (TemplateDeleteIcons.includes(log_type)) {
		secondary_icon = <RemoveTemplateIcon />;
	}

	return (
		<div key={props.log_type} className="relative text-sesh-dark">
			<i className={`${primary_icon_class} fa-2x text`}></i>
			{secondary_icon && (
				<span
					className={`absolute left-5  top-5 inline-block rounded-[50%] bg-base-light p-[2px] leading-[0] `}
				>
					{secondary_icon}
				</span>
			)}
		</div>
	);
}

function AddTemplateIcon() {
	return <CircledIcon font_awesome_class="fas fa-star" />;
}

function RemoveTemplateIcon() {
	return (
		<div key="CircledIcon" className="relative h-[14px] w-[14px]">
			<i
				className={`fas fa-circle absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2`}
			></i>
			<i
				className={`far fa-star absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`}
			></i>
			<i
				className={`fas fa-slash absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`}
			></i>
		</div>
	);
}

function EditIcon() {
	return <CircledIcon font_awesome_class={"fas fa-pen"} />;
}

function EditVoteIcon() {
	return (
		<div key="CircledIcon" className="relative h-[14px] w-[14px]">
			<i
				className={`fas fa-circle absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2`}
			></i>
			<i
				className={`fas fa-edit absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`}
			></i>
		</div>
	);
}

function PremiumIcon() {
	return <CircledIcon font_awesome_class="fas fa-crown" />;
}

function CircledIcon(props: { font_awesome_class: string }) {
	return (
		<div key="CircledIcon" className="relative h-[14px] w-[14px]">
			<i
				className={`fas fa-circle absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2`}
			></i>
			<i
				className={`${props.font_awesome_class} absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`}
			></i>
		</div>
	);
}
